import PropTypes from 'prop-types'
import Head from 'next/head'

const HtmlHead = ({ title }) => (
  <Head>
    <title>{`DPO Product Generator | ${title}`}</title>
    <link rel="icon" href="/favicon.ico" />
  </Head>
)

HtmlHead.propTypes = {
  title: PropTypes.string,
}

export default HtmlHead
